import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { prefetchAreas } from './services/ratingsService';

// Pre-fetch areas immediately (before MSAL / React render) to wake the API,
// warm up EF Core, and cache the response for later use.  The areas endpoint
// is [AllowAnonymous] and contains no user-specific data.
prefetchAreas();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
